import React from 'react';
import PropTypes from 'prop-types';

import displayName from 'component-lib/displayName';
import styles from './AppHeader.scss';

export default function Settings({ onSettingsClick }) {
    return (
        <div className={styles['dropdown-container']}>
            <div
                role="presentation"
                className={styles['icon-settings']}
                data-action={'account-settings'}
                onClick={onSettingsClick}
            />
        </div>
    );
}

Settings.displayName = displayName('AppHeader/Settings');

Settings.propTypes = {
    onSettingsClick: PropTypes.func.isRequired,
};
